import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, LogOut, Menu, User } from "lucide-react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import logo from "../assets/digitalparag/DigirtalParag.png"; // Ensure the logo path is correct

const Uheader = ({ setSidebarOpen }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(true);
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");
  const adminName = localStorage.getItem("adminName");
  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("auth"); // Clear auth from localStorage
    localStorage.removeItem("userId"); // Clear auth from localStorage
    localStorage.removeItem("userName"); // Clear auth from localStorage
    localStorage.removeItem("userEmail"); // Clear auth from localStorage
    navigate("/");
  };

  const handleAdminLogout = () => {
    localStorage.removeItem("auth"); // Clear auth from localStorage
    localStorage.removeItem("userId"); // Clear auth from localStorage
    localStorage.removeItem("userName"); // Clear auth from localStorage
    localStorage.removeItem("userEmail"); // Clear auth from localStorage
    navigate("/admin/users_data");
  };

  useEffect(() => {
    if (userId === null || userId === undefined || userId === "") {
      navigate("/");
    }
  });

  return (
    <header className="bg-gradient-to-r from-white to-orange-200 shadow-md w-full px-4 lg:px-6 h-16 flex  items-center border-b border-gray-200">
      {" "}
      {/* Sidebar Toggle Button for Mobile */}
      <button
        className="lg:hidden text-gray-500 focus:outline-none"
        onClick={() => setSidebarOpen(true)}
      >
        <Menu className="h-6 w-6" />
      </button>
      <div className="relative ms-auto">
        {adminName ? (
          <div className="flex items-center  ms-auto">
            <Link to="#" className="flex items-center fw-bold">
              {userName}
            </Link>
            <p className="text-black text-xs sm:text-sm md:text-base fw-bold">
              Hello, {adminName}
            </p>
            <button
              className="text-red-600 fw-bold hover:text-red-600 flex items-center"
              onClick={handleAdminLogout}
            >
              <LogOut size={20} className="mr-1" />
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        ) : userName ? (
          <div className="flex items-center  ms-auto">
            <Link
              to="/dashboard/dashboard"
              className="flex items-center fw-bold"
            >
              Home
            </Link>
            <p className="text-black text-xs sm:text-sm md:text-base fw-bold">
              Hello, {userName}
            </p>
            <button
              className="text-red-600 fw-bold hover:text-red-600 flex items-center"
              onClick={handleLogout}
            >
              <LogOut size={20} className="mr-1" />
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        ) : (
          <Link
            to="/sign_in"
            className="text-gray-700 hover:text-blue-600 text-xs sm:text-sm md:text-base"
          >
            Login
          </Link>
        )}
      </div>
    </header>
  );
};

export default Uheader;
